var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3861 4.88055C12.0349 6.14027 11.8583 7.44224 11.8611 8.75C11.8611 16.6833 18.3167 23.1389 26.25 23.1389C27.5722 23.1389 28.875 22.9639 30.1194 22.6139C29.098 25.1236 27.3522 27.2722 25.1046 28.7856C22.857 30.299 20.2096 31.1086 17.5 31.1111C9.99445 31.1111 3.8889 25.0055 3.8889 17.5C3.8889 11.8028 7.40834 6.90278 12.3861 4.88055ZM17.5 0C14.0388 0 10.6554 1.02636 7.77753 2.94928C4.89967 4.87221 2.65665 7.60533 1.33212 10.803C0.00758239 14.0007 -0.338976 17.5194 0.336265 20.9141C1.01151 24.3087 2.67822 27.4269 5.12564 29.8744C7.57306 32.3218 10.6913 33.9885 14.0859 34.6637C17.4806 35.339 20.9993 34.9924 24.197 33.6679C27.3947 32.3433 30.1278 30.1003 32.0507 27.2225C33.9736 24.3446 35 20.9612 35 17.5C35 16.6056 34.9222 15.7111 34.8056 14.8556C33.834 16.2179 32.5502 17.3278 31.0618 18.0924C29.5733 18.8569 27.9233 19.2539 26.25 19.25C24.024 19.25 21.8555 18.5431 20.0573 17.231C18.2591 15.9189 16.9241 14.0696 16.2449 11.9498C15.5657 9.82995 15.5774 7.54917 16.2782 5.43639C16.9791 3.32361 18.3329 1.48805 20.1444 0.194444C19.2889 0.0777776 18.3944 0 17.5 0Z",
    fill: "#FFFBD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.537c0c369cba64236be21197da6eb198.svg";
export { ForwardRef as ReactComponent };